import Card from '../../ui/Card';
import Button from '../../ui/Button';
import Icon from '../../ui/Icon';
import { ICONS } from '../../ui/icon-map';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableHeader, TableCell } from '../../ui/Table/Table';
import { CellPlate } from '../../ui/DataTable/cells';

/*
 * "In the workshop on Ejar - no record yet": the cars whose Ejar status is Maintenance at Business Bay / Invygo (the
 * engine's Overview rule; Invygo since 29 Oct 2026) with no open maintenance log on this page (owner, 18 Oct 2026).
 * Hidden when every car has a log.
 */
export default function EjarWorkshopCard({ cars, total, error, onRetry, onAdd }) {
    if (error) {
        return (
            <Card className="mb-4" padding="sm">
                <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-red-700">
                    <Icon glyph={ICONS.alert} size="sm" tone="danger" />
                    <span>The cars in the workshop on Ejar could not be read: {error}</span>
                    <Button size="sm" variant="secondary" onClick={onRetry}>Try again</Button>
                </div>
            </Card>
        );
    }
    if (!cars || cars.length === 0) return null;
    return (
        <Card
            className="mb-4"
            padding="none"
            title={`In the workshop on Ejar - no record yet (${cars.length} of ${total})`}
            subtitle="Ejar shows these cars in Maintenance at Business Bay / Invygo, but they have no open record here. Add a record for each."
        >
            <TableContainer>
                <Table sticky>
                    <TableHead>
                        <TableRow>
                            <TableHeader>#</TableHeader>
                            <TableHeader>Plate</TableHeader>
                            <TableHeader>Car</TableHeader>
                            <TableHeader>Branch</TableHeader>
                            <TableHeader>Ejar status</TableHeader>
                            {onAdd && <TableHeader>Action</TableHeader>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {cars.map((c, i) => (
                            <TableRow key={c.plate}>
                                <TableCell>{i + 1}</TableCell>
                                <TableCell><CellPlate>{c.plate}</CellPlate></TableCell>
                                <TableCell>{`${c.make || ''} ${c.model || ''}`.trim() || '—'}</TableCell>
                                <TableCell>{c.branch || '—'}</TableCell>
                                <TableCell>{c.ejarStatus || '—'}</TableCell>
                                {onAdd && (
                                    <TableCell>
                                        <Button size="sm" variant="secondary" onClick={() => onAdd(c)}
                                            leadingIcon={<Icon glyph={ICONS.plus} size="sm" />}>
                                            Add record
                                        </Button>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
    );
}
